import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SceneConifg } from "./config";
export var getProtocolAction = function getProtocolAction(url) {
  return SceneConifg.REGISTERED_PROTOCOLS[url.substring(0, url.indexOf('://'))];
};
export var AJAXError = /*#__PURE__*/function (_Error) {
  _inherits(AJAXError, _Error);
  var _super = _createSuper(AJAXError);
  /**
   * The response's HTTP status code.
   */

  /**
   * The response's HTTP status text.
   */

  /**
   * The request's URL.
   */

  /**
   * The response's body.
   */

  function AJAXError(status, statusText, url, body) {
    var _this;
    _classCallCheck(this, AJAXError);
    _this = _super.call(this, "AJAXError: ".concat(statusText, " (").concat(status, "): ").concat(url));
    _this.status = status;
    _this.statusText = statusText;
    _this.url = url;
    _this.body = body;
    return _this;
  }
  return _createClass(AJAXError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function makeXMLHttpRequest(requestParameters, callback) {
  var xhr = new XMLHttpRequest();
  var url = Array.isArray(requestParameters.url) ? requestParameters.url[0] : requestParameters.url;
  xhr.open(requestParameters.method || 'GET', url, true);
  if (requestParameters.type === 'arrayBuffer') {
    xhr.responseType = 'arraybuffer';
  }
  for (var k in requestParameters.headers) {
    if (requestParameters.headers.hasOwnProperty(k)) {
      xhr.setRequestHeader(k, requestParameters.headers[k]);
    }
  }
  if (requestParameters.type === 'json') {
    xhr.responseType = 'text';
    xhr.setRequestHeader('Accept', 'application/json');
  }
  xhr.withCredentials = requestParameters.credentials === 'include';
  xhr.onerror = function () {
    callback(new Error(xhr.statusText));
  };
  xhr.onload = function () {
    if ((xhr.status >= 200 && xhr.status < 300 || xhr.status === 0) && xhr.response !== null) {
      var _data = xhr.response;
      if (requestParameters.type === 'json') {
        // We're manually parsing JSON here to get better error messages.
        try {
          _data = JSON.parse(xhr.response);
        } catch (err) {
          return callback(err);
        }
      }
      callback(null, _data, xhr.getResponseHeader('Cache-Control'), xhr.getResponseHeader('Expires'), xhr);
    } else {
      var body = new Blob([xhr.response], {
        type: xhr.getResponseHeader('Content-Type')
      });
      callback(new AJAXError(xhr.status, xhr.statusText, url.toString(), body));
    }
  };
  // @ts-ignore
  xhr.cancel = xhr.abort;
  xhr.send(requestParameters.body);
  return xhr;
}
export function makeXMLHttpRequestPromise(requestParameters) {
  return new Promise(function (resolve, reject) {
    makeXMLHttpRequest(requestParameters, function (error, data, cacheControl, expires, xhr) {
      if (error) {
        reject({
          err: error,
          data: null,
          xhr: xhr
        });
      } else {
        resolve({
          err: null,
          data: data,
          cacheControl: cacheControl,
          expires: expires,
          xhr: xhr
        });
      }
    });
  });
}
function makeRequest(requestParameters, callback) {
  // TODO: isWorker
  // makeFetchRequest

  return makeXMLHttpRequest(requestParameters, callback);
}
export var getJSON = function getJSON(requestParameters, callback) {
  var action = getProtocolAction(requestParameters.url) || makeRequest;
  return action(_objectSpread(_objectSpread({}, requestParameters), {}, {
    type: 'json'
  }), callback);
};
export var getArrayBuffer = function getArrayBuffer(requestParameters, callback) {
  var action = getProtocolAction(requestParameters.url) || makeRequest;
  return action(_objectSpread(_objectSpread({}, requestParameters), {}, {
    type: 'arrayBuffer'
  }), callback);
};
export var postData = function postData(requestParameters, callback) {
  return makeRequest(_objectSpread(_objectSpread({}, requestParameters), {}, {
    method: 'POST'
  }), callback);
};
export var getData = function getData(requestParameters, callback) {
  return makeRequest(_objectSpread(_objectSpread({}, requestParameters), {}, {
    method: 'GET'
  }), callback);
};
export function sameOrigin(url) {
  var a = window.document.createElement('a');
  a.href = url;
  return a.protocol === window.document.location.protocol && a.host === window.document.location.host;
}
var transparentPngUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
function arrayBufferToImage(data, callback) {
  var img = new window.Image();
  var URL = window.URL || window.webkitURL;
  img.crossOrigin = 'anonymous';
  img.onload = function () {
    callback(null, img);
    URL.revokeObjectURL(img.src);
    // prevent image dataURI memory leak in Safari;
    // but don't free the image immediately because it might be uploaded in the next frame
    // https://github.com/mapbox/mapbox-gl-js/issues/10226
    img.onload = null;
    window.requestAnimationFrame(function () {
      img.src = transparentPngUrl;
    });
  };
  img.onerror = function () {
    return callback(new Error('Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
  };
  var blob = new Blob([new Uint8Array(data)], {
    type: 'image/png'
  });
  img.src = data.byteLength ? URL.createObjectURL(blob) : transparentPngUrl;
}
function arrayBufferToImageBitmap(data, callback) {
  var blob = new Blob([new Uint8Array(data)], {
    type: 'image/png'
  });
  createImageBitmap(blob).then(function (imgBitmap) {
    callback(null, imgBitmap);
  }).catch(function (e) {
    callback(new Error("Could not load image because of ".concat(e.message, ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")));
  });
}
export var getImage = function getImage(requestParameters, callback, transformResponse) {
  // request the image with XHR to work around caching issues
  // see https://github.com/mapbox/mapbox-gl-js/issues/1470
  var optionFunc = function optionFunc(err, imgData) {
    if (err) {
      callback(err);
    } else if (imgData) {
      var imageBitmapSupported = typeof createImageBitmap === 'function';
      var transformImgData = transformResponse ? transformResponse(imgData) : imgData;
      if (imageBitmapSupported) {
        arrayBufferToImageBitmap(transformImgData, callback);
      } else {
        arrayBufferToImage(transformImgData, callback);
      }
    }
  };
  if (requestParameters.type === 'json') {
    return getJSON(requestParameters, optionFunc);
  } else {
    return getArrayBuffer(requestParameters, optionFunc);
  }
};
export var formatImage = function formatImage(imgData, callback) {
  var imageBitmapSupported = typeof createImageBitmap === 'function';
  if (imageBitmapSupported) {
    arrayBufferToImageBitmap(imgData, callback);
  } else {
    arrayBufferToImage(imgData, callback);
  }
};